<template>
  <v-tooltip v-if="value != undefined" bottom allow-overflow>
    <span slot="activator">
      <v-icon style="cursor: pointer; color: lightgrey;"
              v-clipboard:copy="value"
              v-clipboard:success="onCopy">file_copy</v-icon>
    </span>
    <span><pre>{{ value }}</pre><br/>{{ hint }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'MPayCopyButton',
  props: ['value'],
  data: () => ({
    hint: 'Click to copy to Buffer',
  }),
  methods: {
    onCopy() {
      this.hint = 'Value copied to buffer';
      setTimeout(() => {
        this.hint = 'Click to copy to Buffer';
      }, 3000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MPayCopyButton.vue